import { render, staticRenderFns } from "./serverPdfBasePlus.vue?vue&type=template&id=2def6b04&scoped=true"
import script from "./serverPdfBasePlus.vue?vue&type=script&lang=js"
export * from "./serverPdfBasePlus.vue?vue&type=script&lang=js"
import style0 from "./serverPdfBasePlus.vue?vue&type=style&index=0&id=2def6b04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def6b04",
  null
  
)

export default component.exports